<template>
  <div class="maincen">
    <div class="catalog">
      <div class="line"></div>
      <div class="catalogTit">我要出版</div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>
<style lang="scss" scoped>
.maincen {
  margin: 0 0px;
}
.catalog {
  overflow: hidden;
  padding: 20px 0 10px;
  border-bottom: 1px solid #e6e6e6;
  .line {
    width: 8px;
    height: 18px;
    background: #0082F0;
    float: left;
    margin-right: 8px;
  }
  .catalogTit {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
}
.course {
}
.itemnewImg {
  margin-top: 10px;
  width: 100%;
  height: 117px;
  img {
    height: 100%;
    width: 100%;
  }
}
.addImg {
  margin-top: 10px;
  width: 185px;
  height: 117px;
  margin-bottom: 60px;
  img {
    height: 100%;
    width: 100%;
  }
}
.itemTit {
  font-size: 16px;
  color: #0082F0;
  margin: 17px 0 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 30px;
  cursor: pointer;
  &:hover {
    color: #0082F0;
  }
}
</style>
<style lang="scss">
@import '../../assets/css/centertabs.scss';
</style>
